import { combineReducers } from '@reduxjs/toolkit';

import objectives from './objectives/sliceReducer';

const reducer = combineReducers({
  objectives: objectives.reducer,
});

export default reducer;
